import {
    Loader,
    Alert,
    Button
} from 'arag-ui-lib';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import { PRIMARY, QUATERNARY, RIGHT, DOTS, ERROR, MEDIUM, SIZE_MD, } from '../../helpers/constants';
import ModalWrapper from '../../helpers/modalWrapper';

const DeleteAnswerModal = (props) => {
    const {
        isOpen, 
        onClose, 
        onConfirm, 
        isLoading, 
        errorMessage,
        deleteModalQuestionMachineName
    } = props;
    return (
        <ModalWrapper
            isOpen={isOpen}
            onClose={onClose}
            size={SIZE_MD}
            title={CONTENT_STRINGS.DELETE_ITEM_TITLE}
            modalTestId={`delete-modal-${deleteModalQuestionMachineName}`}
            buttonTestId={`delete-modal-close-button-${deleteModalQuestionMachineName}`}
        >
            <div className={"form-group"} style={{display: 'flex', flexDirection: 'row', gap: '5px'}}>
                <Button
                    onClick={onConfirm} 
                    label={CONTENT_STRINGS.YES}
                    variant={PRIMARY}
                    arrowDirection={RIGHT}
                    buttonTestId={`delete-modal-${deleteModalQuestionMachineName}-yes`}
                    disabled={isLoading}
                />
                <Button
                    onClick={onClose}
                    label={CONTENT_STRINGS.CANCEL}
                    variant={QUATERNARY}
                    arrowDirection={RIGHT}
                    buttonTestId={`delete-modal-${deleteModalQuestionMachineName}-cancel`}
                    disabled={isLoading}
                />
                {isLoading 
                ?
                    <Loader variant={DOTS} dotSize={MEDIUM}/>
                : 
                    null
                }
            </div>
            {errorMessage
            ?
                <Alert label={errorMessage} variant={ERROR} />
            : 
                null
            }
        </ModalWrapper>
    )
};

export default DeleteAnswerModal;